import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitosuratcab() {



    const cardData = {

keyword: "Mumbai to Surat Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Surat Cab services for business travelers, families, tourists, corporate clients, and outstation passengers. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with professional chauffeurs for a smooth interstate journey. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, flexible travel schedules, 24/7 customer support, and transparent pricing, we ensure a hassle-free and enjoyable road trip to Surat, Gujarat's vibrant commercial city known for its diamond industry, textile markets, riverside attractions, temples, and cultural landmarks.",

topPlaces: [
    {
        title: "Dumas Beach",
        description:
            "Dumas Beach is one of Surat's most popular tourist attractions, located along the Arabian Sea coastline. Known for its unique black sand and refreshing sea breeze, the beach attracts families, couples, and tourists seeking relaxation and scenic views. Visitors enjoy evening walks, local street food, photography, and beautiful sunsets. The lively atmosphere and coastal charm make Dumas Beach an essential stop during a Mumbai to Surat cab trip."
    },
    {
        title: "Sarthana Nature Park",
        description:
            "Sarthana Nature Park is a well-maintained zoological and botanical park that offers an enjoyable experience for families and nature lovers. The park houses various species of animals, birds, reptiles, and lush green gardens. Visitors can spend quality time exploring the wildlife exhibits while enjoying a peaceful natural environment within the city."
    },
    {
        title: "Dutch Garden",
        description:
            "Dutch Garden is a historic attraction featuring beautifully landscaped grounds and colonial-era monuments built during the Dutch presence in Surat. The garden is known for its peaceful atmosphere, heritage structures, and scenic surroundings. History enthusiasts and tourists visit to learn about Surat's trading history and enjoy a relaxing stroll through the well-maintained gardens."
    },
    {
        title: "Science Centre and Planetarium",
        description:
            "The Science Centre and Planetarium is one of Surat's most educational and entertaining attractions. It features interactive science exhibits, a modern planetarium, galleries, and learning experiences for visitors of all ages. Families, students, and science enthusiasts enjoy exploring the facility while gaining knowledge through engaging displays and presentations."
    },
    {
        title: "Ambika Niketan Temple",
        description:
            "Ambika Niketan Temple is a revered Hindu temple dedicated to Goddess Ambika and is one of the most visited religious sites in Surat. Situated on the banks of the Tapi River, the temple attracts devotees throughout the year. The peaceful atmosphere, spiritual significance, and beautiful location make it an important stop for pilgrims and visitors."
    },
    {
        title: "Surat Castle",
        description:
            "Surat Castle is a historic fort built during the sixteenth century to protect the city from invasions and pirate attacks. The fort showcases impressive architecture and offers insight into Surat's rich historical and maritime heritage. Visitors enjoy exploring its ancient structure while learning about the city's importance as a major trading center."
    },
    {
        title: "Tapi River Front",
        description:
            "The Tapi River Front has become one of Surat's most attractive leisure destinations, offering scenic river views, landscaped walkways, and recreational spaces. Visitors enjoy evening strolls, family outings, and photography while admiring the beautifully developed waterfront. The area provides a refreshing escape from the city's busy commercial zones."
    },
    {
        title: "ISKCON Temple Surat",
        description:
            "ISKCON Temple Surat is a spiritual and cultural center dedicated to Lord Krishna. The temple is known for its beautiful architecture, devotional programs, religious festivals, and peaceful atmosphere. Devotees and tourists visit to participate in prayers, experience spiritual teachings, and enjoy the serene environment."
    },
    {
        title: "Gopi Talav",
        description:
            "Gopi Talav is a historic lake and recreational destination that has been beautifully redeveloped as a family-friendly attraction. The area features boating facilities, landscaped gardens, cultural spaces, and entertainment zones. Visitors enjoy spending time near the water while exploring one of Surat's important heritage landmarks."
    },
    {
        title: "Textile and Diamond Markets",
        description:
            "Surat is globally recognized as the Diamond City and Textile Hub of India. Visitors can explore bustling textile markets offering sarees, dress materials, and garments, as well as the city's famous diamond trading districts. Shopping enthusiasts and business travelers appreciate the opportunity to experience Surat's thriving commercial culture and vibrant marketplace atmosphere."
    }
],



services: [
{
name: "Mumbai to Surat Cab",
description: "Mumbai Airport Cab offers Mumbai to Surat Cab service for safe, comfortable, and affordable intercity travel between Maharashtra and Gujarat. Whether you are travelling for business meetings, corporate events, family visits, tourism, shopping trips, educational travel, or group transportation, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury vehicles. Our professional chauffeurs ensure a smooth highway journey with doorstep pickup, flexible schedules, one way and round trip options, transparent pricing, and 24x7 booking support. We provide convenient pickups from Mumbai City, Mumbai Airport, Navi Mumbai, Thane, and surrounding locations, making every trip to Surat comfortable, reliable, and stress-free."
},
{
name: "Mumbai to Surat Taxi",
description: "Book Mumbai to Surat Taxi with Mumbai Airport Cab for convenient and hassle-free travel. Our experienced drivers, clean AC vehicles, affordable fares, and flexible pickup options ensure a comfortable journey for families, corporate travellers, and business professionals."
},
{
name: "Mumbai to Surat Taxi Fare",
description: "Get affordable Mumbai to Surat Taxi Fare with Mumbai Airport Cab. We offer transparent pricing, no hidden charges, multiple vehicle options, and economical travel packages for one way and round trip journeys."
},
{
name: "Mumbai to Surat Cab Fare",
description: "Mumbai Airport Cab provides competitive Mumbai to Surat Cab Fare with reliable service, professional chauffeurs, comfortable vehicles, and flexible travel schedules for every traveller."
},
{
name: "Cab from Mumbai to Surat",
description: "Choose a Cab from Mumbai to Surat with Mumbai Airport Cab and enjoy a safe, comfortable, and reliable journey with experienced drivers and premium AC vehicles."
},
{
name: "Mumbai to Surat Car Rental",
description: "Book Mumbai to Surat Car Rental with chauffeur-driven vehicles for flexible and comfortable travel. We offer Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicle options for all travel requirements."
},
{
name: "Mumbai to Surat Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Surat Cab Booking with instant confirmation, 24x7 customer support, professional drivers, and multiple vehicle choices for business and leisure travel."
},
{
name: "Mumbai to Surat One Way Cab",
description: "Travel conveniently with Mumbai to Surat One Way Cab service featuring fixed pricing, comfortable AC vehicles, professional chauffeurs, and hassle-free pickup and drop facilities."
},
{
name: "Mumbai to Surat Round Trip Cab",
description: "Mumbai Airport Cab provides Mumbai to Surat Round Trip Cab packages for business visits, family travel, shopping trips, corporate meetings, and multi-day travel requirements."
},
{
name: "Mumbai to Surat Outstation Cab",
description: "Book Mumbai to Surat Outstation Cab for comfortable long-distance travel with premium vehicles, experienced drivers, and customized travel packages designed for leisure and business travellers."
},
{
name: "Mumbai to Surat Taxi Service",
description: "Mumbai Airport Cab offers Mumbai to Surat Taxi Service with safe transportation, affordable fares, clean vehicles, and reliable chauffeurs for a smooth and stress-free travel experience."
},
{
name: "Mumbai to Surat Car Hire",
description: "Choose Mumbai to Surat Car Hire with Mumbai Airport Cab for premium chauffeur-driven travel featuring comfortable seating, flexible schedules, and personalized service."
},
{
name: "Mumbai to Surat Innova Cab",
description: "Mumbai Airport Cab provides Mumbai to Surat Innova Cab service with spacious seating, ample luggage space, premium comfort, and reliable transportation for families and small groups."
},
{
name: "Mumbai to Surat Ertiga Cab",
description: "Book Mumbai to Surat Ertiga Cab for economical and comfortable family travel with AC comfort, professional drivers, affordable rates, and convenient pickup options."
},
{
name: "Mumbai to Surat SUV Cab",
description: "Mumbai Airport Cab offers Mumbai to Surat SUV Cab service for larger families, business teams, and groups seeking spacious interiors, premium comfort, and smooth long-distance travel."
},
{
name: "Mumbai Airport to Surat Cab",
description: "Book Mumbai Airport to Surat Cab with direct pickup from domestic and international terminals. We provide flight tracking, luggage assistance, professional chauffeurs, and comfortable AC vehicles for seamless airport transfers."
},
{
name: "Navi Mumbai to Surat Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Surat Cab service with doorstep pickup, affordable fares, comfortable vehicles, and reliable travel solutions for families and corporate travellers."
},
{
name: "Thane to Surat Cab",
description: "Choose Thane to Surat Cab with Mumbai Airport Cab for dependable transportation, premium vehicles, experienced drivers, and flexible travel schedules tailored to your needs."
},
{
name: "Mumbai to Surat Business Travel Cab",
description: "Mumbai Airport Cab provides Mumbai to Surat Business Travel Cab service designed for corporate executives, business owners, professionals, and teams requiring punctual, comfortable, and efficient transportation for meetings, conferences, industrial visits, and commercial travel."
}
],

tableData: [
["Mumbai to Surat Cab","Mumbai to Surat Taxi"],
["Mumbai to Surat Taxi Fare","Mumbai to Surat Cab Fare"],
["Cab from Mumbai to Surat","Mumbai to Surat Car Rental"],
["Mumbai to Surat Cab Booking","Mumbai to Surat One Way Cab"],
["Mumbai to Surat Round Trip Cab","Mumbai to Surat Outstation Cab"],
["Mumbai to Surat Taxi Service","Mumbai to Surat Car Hire"],
["Mumbai to Surat Innova Cab","Mumbai to Surat Ertiga Cab"],
["Mumbai to Surat SUV Cab","Mumbai Airport to Surat Cab"],
["Navi Mumbai to Surat Cab","Thane to Surat Cab"],
["Mumbai to Surat Business Travel Cab","Mumbai to Surat Corporate Cab"]
],



whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Khandala Taxi Service",
WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Khandala Taxi services for families, tourists, couples, corporate travelers, and weekend vacationers seeking a comfortable journey."
},
{
WhyChooseheading: "Perfect Weekend Getaway Transportation",
WhyChoosedescription: "Khandala is one of the most popular hill destinations near Mumbai, attracting visitors with its scenic beauty, pleasant weather, and relaxing atmosphere."
},
{
WhyChooseheading: "Comfortable and Hassle-Free Travel",
WhyChoosedescription: "Our taxi service ensures a smooth travel experience with clean vehicles, experienced drivers, and convenient door-to-door transportation."
},
{
WhyChooseheading: "Multiple Vehicle Options Available",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to passenger count and travel requirements."
},
{
WhyChooseheading: "One-Way and Round Trip Booking",
WhyChoosedescription: "Whether you need a one-way taxi, round trip package, same-day return, or customized sightseeing itinerary, we provide flexible booking options."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
},
{
WhyChooseheading: "Professional Drivers and Safe Journey",
WhyChoosedescription: "Our trained drivers and regularly maintained vehicles ensure a safe, comfortable, and enjoyable journey to Khandala."
},
{
WhyChooseheading: "Ideal for Families, Couples, and Groups",
WhyChoosedescription: "From romantic vacations and family holidays to corporate outings and group tours, we offer suitable travel solutions for every traveler."
}
]
};

const faqData = [
{
question: "What is the Mumbai to Khandala Taxi Fare?",
answer: "Taxi fare depends on the vehicle type, travel duration, pickup location, and trip requirements. Contact Mumbai Airport Cabs for the latest fare details."
},
{
question: "Can I book a one-way taxi from Mumbai to Khandala?",
answer: "Yes, one-way taxi services are available along with round-trip and customized travel packages."
},
{
question: "Which vehicle is suitable for Mumbai to Khandala travel?",
answer: "Sedan cars, Ertiga, and Innova Crysta are among the most popular choices for comfortable hill station travel."
},
{
question: "Are same-day return trips available?",
answer: "Yes, customers can choose same-day return trips depending on their sightseeing plans and schedule."
},
{
question: "Can families use this service for vacations?",
answer: "Yes, families frequently choose Mumbai Airport Cabs for holidays, picnics, and weekend trips to Khandala."
},
{
question: "Do you provide Tempo Travellers for group travel?",
answer: "Yes, Tempo Travellers and larger vehicles are available for family groups, corporate outings, and sightseeing tours."
},
{
question: "Can I get pickup from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
},
{
question: "Can sightseeing places be included during the trip?",
answer: "Yes, customers can visit Rajmachi Point, Duke's Nose, Tiger's Leap, Bhushi Dam, and other nearby attractions."
},
{
question: "Is advance booking recommended?",
answer: "Yes, advance booking helps secure your preferred vehicle and ensures a smooth travel experience."
},
{
question: "How can I book a Mumbai to Khandala Taxi?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Sagar More",
feedback:
"The taxi arrived exactly on schedule and the entire journey to Khandala was comfortable. The driver was polite and familiar with all major routes.",
rating: 5
},
{
id: 2,
name: "Mrs. Priti Shah",
feedback:
"Mumbai Airport Cabs made our Khandala weekend getaway completely stress-free. The vehicle was clean, spacious, and the service exceeded our expectations.",
rating: 5
}
];



































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Surat Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-surat-cab.jpg",
"description": "Book Mumbai to Surat cab service for safe, comfortable, and affordable long-distance travel. Mumbai Airport Cabs offers reliable taxi service with professional drivers, clean vehicles, transparent pricing, and flexible one-way and round-trip options between Mumbai and Surat.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-surat-cab"
}
};





    return (
        <div>


<Helmet>
  <title>Mumbai to Surat Cab | Taxi Service & Fare | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Surat cab service at affordable fares. Reliable taxi service with professional drivers, comfortable cars, and one-way and round-trip options for smooth intercity travel."
/>

<meta
 name="keywords"
 content="mumbai to surat cab, mumbai to surat taxi, mumbai to surat taxi fare, mumbai to surat cab fare, cab from mumbai to surat, mumbai to surat car rental, mumbai to surat cab booking, mumbai to surat one way cab, mumbai to surat round trip cab, mumbai to surat outstation cab, surat taxi from mumbai, surat cab booking mumbai, long distance cab mumbai to surat, best taxi service mumbai to surat"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>








            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/94.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitosuratcab;